import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IInfo, Info } from '../../../../../core/common';
import { IV6OptionTranslation, V6OptionTranslation } from '../../../../../core/models';
import { ProductService } from '../../../../../core/services/product.service';

@Component({
  selector: 'app-edit-translation',
  templateUrl: './edit-translation.component.html',
  styleUrls: ['./edit-translation.component.scss']
})
export class EditTranslationComponent implements OnInit {

  constructor(private productService: ProductService,
    private router: Router,
    private route: ActivatedRoute) {
    if (this.productService.editTranslation && this.productService.editTranslation.id) {
      this.editTranslation = this.productService.editTranslation;
      this.value = this.productService.editTranslation.optionApplicableProducts.split('|');
    } else {
      this.router.navigate(['../'], { relativeTo: this.route });
    }}

  ngOnInit() {
    this.productService.GetProductCode().subscribe(productCodeResponse => {
      this.productCode = productCodeResponse;
      this.dummyProductCode = this.productCode; 
    });
  }
  editTranslation: IV6OptionTranslation = new V6OptionTranslation();
  public value: any = [];
  productCode = [];
  dummyProductCode = [];
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  public infoMessage: IInfo = new Info();
  isSubmitted: boolean = false;
  saveInProcess: boolean = false;
  validateForm(): boolean {
    return true;
  }
  handleFilter(event) {
    let keys = Array.from(this.dummyProductCode.values());
    this.productCode = keys.filter(
      (s) => s ? s.toLowerCase().indexOf(event.toLowerCase()) !== -1 : false
    );
  }

  editTranslationToSave(): void {
    this.isSubmitted = true;
    if (this.value) {
      this.editTranslation.optionApplicableProducts = this.value.join("|");
    }
    this.editTranslation.active = true;
    //return;
    if (!this.validateForm()) {
      return;
    }
    this.infoMessage = new Info();
    this.inProgressMessage = true;
    this.saveInProcess = true;
    this.infoMessage.genericInProgress = this.infoMessage.genericInProgress;
    this.productService.AddTranslation(this.editTranslation).subscribe(response => {
      if (response) {
        this.infoMessage.genericInProgress = "";
        this.saveInProcess = false;
        this.infoMessage.genericSuccess = this.infoMessage.genericSuccess;
      } else {
        this.infoMessage.genericError = this.infoMessage.genericError;
      }
      this.editTranslation = new V6OptionTranslation();
      this.value = [];
    });
  }
}
